import React, { Ref, forwardRef } from 'react';

import { EssenceViewModel } from './essence-models';
import { EssenceSettings } from './essence-edit-form';

interface Props {
  model: EssenceViewModel;
  nmosServiceActive: boolean;
}
export interface EssenceAddFormRef {
  submitAddEssence: () => Promise<void>;
}
export const AddEssence = forwardRef((props: Props, ref: Ref<EssenceAddFormRef>) => {
  const model = props.model;
  const nmosServiceActive = props.nmosServiceActive;

  return (
    <div className="mk-add-essence">
      <EssenceSettings ref={ref} model={model} nmosServiceActive={nmosServiceActive} />
    </div>
  );
});

AddEssence.displayName = 'AddEssence';
